// extracted by mini-css-extract-plugin
export var content = "_ad-3";
export var list = "_ad-4";
export var settingsContent = "_ad-7";
export var settingsPanel = "_ad-8";
export var state = "_ad-6";
export var triggerBadge = "_ad-2";
export var triggerButton = "_ad-1";
export var triggerShell = "_ad-0";
export var unreadDot = "_ad-5";